import { cx } from '@vizit/theme';
import { Switch as AriaSwitch, composeRenderProps } from 'react-aria-components';
import { knobClasses, switchClasses, trackClasses } from './styles';
import type { SwitchProps } from './types';

/**
 * The Switch component is a toggle control used to turn a single setting on or
 * off. It wraps React Aria's Switch, so it exposes `role="switch"` and derives
 * its accessible name from its label (`children`) or `aria-label`.
 *
 * @example
 * <Switch isSelected={isOn} onChange={setIsOn}>Hide lower-scoring images</Switch>
 */
function Switch(props: SwitchProps) {
  const { children, className: classNameProp, ...other } = props;

  return (
    <AriaSwitch {...other} className={composeRenderProps(classNameProp, (className) => cx(switchClasses(), className))}>
      {({ isSelected, isDisabled }) => (
        <>
          <span className={trackClasses({ isSelected, isDisabled })}>
            <span className={knobClasses({ isSelected })} />
          </span>
          {children}
        </>
      )}
    </AriaSwitch>
  );
}

export { Switch };
